import { FilterValues } from "@vms/SelectFilters/SelectFiltersTypes";
import { useMemo } from "react";
import { useCurrentCurrency } from "@vms/Country/useCurrentCountryCode";
import { getFiltersChanges } from "@vms/SelectFilters/getFiltersChanges";

export function useFiltersText(filters: FilterValues): string {
    const currentCurrency = useCurrentCurrency();
    const filtersChanges = useMemo(
        () => getFiltersChanges(filters, currentCurrency),
        [filters, currentCurrency]
    );

    return useMemo(() => {
        const { isSomeFieldChanged, changedFieldsCount, lastChangedFieldName } = filtersChanges;

        if (!isSomeFieldChanged) {
            return '';
        } else if (changedFieldsCount === 1) {
            return `your results are currently filtered by <b>${lastChangedFieldName}</b>`;
        } else {
            return 'your results have <b>multiple</b> filters applied';
        }
    }, [filtersChanges]);
}